<div class="container-fluid profile-details-new">
    <div class="card">
        <div class="card-body p-4">
            <div class="row align-items-center mb-3">
                <div class="col-md-8">
                    <span class="demo-badge">{{ demoBanner }}</span>
                    <h5 class="color-primary font-weight-bold mb-0 mt-2">Student Profile — New Design</h5>
                </div>
                <div class="col-md-4 text-md-right">
                    <button class="btn btn-outline-secondary btn-sm mr-2" (click)="openLegacyProfile()">View current design</button>
                    <button class="btn btn-outline-primary" (click)="backFunction()">
                        <i class="fa fa-long-arrow-left" aria-hidden="true"></i> Back
                    </button>
                </div>
            </div>

            <!-- Student summary header -->
            <div class="student-hero-card">
                <div class="hero-avatar">
                    <img [src]="profileAvatar" alt="Student">
                </div>
                <div class="hero-info">
                    <h4 class="hero-name text-capitalize">{{ studentProfile.first_name }} {{ studentProfile.last_name }}</h4>
                    <div class="hero-meta">
                        <span class="meta-chip"><i class="fa fa-graduation-cap"></i> Grade {{ studentProfile.grade_name }}</span>
                        <span class="meta-chip meta-active"><i class="fa fa-check-circle"></i> {{ studentProfile.status }}</span>
                        <span class="meta-chip"><i class="fa fa-envelope-o"></i> {{ studentProfile.email_id }}</span>
                    </div>
                </div>
                <div class="hero-side d-none d-md-flex">
                    <div class="hero-stat">
                        <span class="stat-label">Student ID</span>
                        <span class="stat-value">{{ studentProfile.school_idno }}</span>
                    </div>
                    <div class="hero-stat">
                        <span class="stat-label">Registered</span>
                        <span class="stat-value">{{ studentProfile.registration_date }}</span>
                    </div>
                </div>
            </div>

            <!-- Main tabs -->
            <div class="row mt-4">
                <div class="col-12">
                    <ul class="nav nav-tabs profile-main-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'profile'" href="javascript:void(0)"
                               (click)="setTab('profile')">Profile</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'classes'" href="javascript:void(0)"
                               (click)="setTab('classes')">Class Details</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'attendance'" href="javascript:void(0)"
                               (click)="setTab('attendance')">Attendance (Daywise)</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'curriculum'" href="javascript:void(0)"
                               (click)="setTab('curriculum')">Curriculum</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'communications'" href="javascript:void(0)"
                               (click)="setTab('communications')">Communications</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="activeTab === 'reports'" href="javascript:void(0)"
                               (click)="setTab('reports')">Reports</a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="tab-content-panel mt-3">
                <!-- Profile: Personal & Parent -->
                <div *ngIf="activeTab === 'profile'">
                    <ul class="nav profile-sub-tabs">
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="profileSubTab === 'personal'" href="javascript:void(0)"
                               (click)="setProfileSubTab('personal')">
                                <i class="fa fa-user-o mr-1"></i> Personal Details
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [class.active]="profileSubTab === 'parent'" href="javascript:void(0)"
                               (click)="setProfileSubTab('parent')">
                                <i class="fa fa-users mr-1"></i> Parent / Guardian
                            </a>
                        </li>
                    </ul>

                    <!-- Personal -->
                    <div *ngIf="profileSubTab === 'personal'" class="profile-info-panel">
                        <div class="row">
                            <div class="col-lg-4 col-md-6 mb-3" *ngFor="let group of personalInfoGroups">
                                <div class="info-group-card">
                                    <div class="info-group-header">
                                        <i class="fa {{ group.icon }}"></i>
                                        <span>{{ group.title }}</span>
                                    </div>
                                    <div class="info-group-body">
                                        <div class="info-field" *ngFor="let field of group.fields">
                                            <span class="field-label">{{ field.label }}</span>
                                            <span class="field-value"
                                                  [class.text-capitalize]="field.capitalize"
                                                  [class.value-success]="field.highlight === 'success'">
                                                {{ getStudentFieldValue(field.valueKey) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Parent -->
                    <div *ngIf="profileSubTab === 'parent'" class="profile-info-panel">
                        <div class="parent-selector">
                            <button type="button" class="parent-pill" [class.active]="selectedParent === 1"
                                    (click)="parentTabChange(1)">Parent 1</button>
                            <button type="button" class="parent-pill" [class.active]="selectedParent === 2"
                                    (click)="parentTabChange(2)">Parent 2</button>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-3" *ngFor="let group of parentInfoGroups">
                                <div class="info-group-card">
                                    <div class="info-group-header">
                                        <i class="fa {{ group.icon }}"></i>
                                        <span>{{ group.title }}</span>
                                    </div>
                                    <div class="info-group-body info-group-body-grid">
                                        <div class="info-field" *ngFor="let field of group.fields">
                                            <span class="field-label">{{ field.label }}</span>
                                            <span class="field-value" [class.text-capitalize]="field.capitalize">
                                                {{ getParentFieldValue(field.key) }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Class Details -->
                <div *ngIf="activeTab === 'classes'">
                    <div class="table-responsive student-profile" style="overflow-y: auto; max-height: 55vh">
                        <table class="table table-bordered">
                            <thead style="background: #cdd9f6">
                            <tr>
                                <th>Class Name</th>
                                <th>Class Code</th>
                                <th>Subject</th>
                                <th>Grade</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Joined Date</th>
                                <th>Dropped Date</th>
                                <th>Notify Parent</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let classData of classList">
                                <td class="color-primary font-weight-bold">{{ classData.class_name }}</td>
                                <td>{{ classData.class_code }}</td>
                                <td>{{ classData.subject }}</td>
                                <td>{{ classData.grade }}</td>
                                <td>{{ classData.start_date }}</td>
                                <td>{{ classData.end_date }}</td>
                                <td>{{ classData.joining_date }}</td>
                                <td>{{ classData.drafted_date }}</td>
                                <td>{{ classData.notify_status }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Attendance -->
                <div *ngIf="activeTab === 'attendance'">
                    <div class="form-group col-md-4 pl-0">
                        <label class="font-weight-bold">Class List</label>
                        <ng-select [items]="classFilterOptions" bindLabel="class_name" bindValue="class_id"
                                   placeholder="Please Select" [ngModel]="selectedClassId"
                                   (change)="attendanceFilter($event)"></ng-select>
                    </div>
                    <div class="table-responsive student-profile" style="overflow-y: auto; max-height: 55vh">
                        <table class="table table-bordered">
                            <thead style="background: #cdd9f6">
                            <tr>
                                <th>Class Name</th>
                                <th>Date</th>
                                <th>Time Slot</th>
                                <th>Attendance</th>
                                <th>Make-up Class</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="attendanceListData.length === 0">
                                <td colspan="5" class="text-center color-primary">No Data Available!</td>
                            </tr>
                            <tr *ngFor="let attendance of attendanceListData">
                                <td class="color-primary font-weight-bold">{{ attendance.class_name }}</td>
                                <td>{{ attendance.date }}</td>
                                <td>{{ attendance.start_time }} - {{ attendance.end_time }}</td>
                                <td>
                                    <i *ngIf="attendance.attendance === '1'" class="fa fa-check-circle color-green" style="font-size: 18px"></i>
                                    <i *ngIf="attendance.attendance === '0'" class="fa fa-times-circle color-red" style="font-size: 18px"></i>
                                </td>
                                <td>
                                    <button *ngIf="attendance.attendance === '0' && !attendance.makeup"
                                            class="btn-sm-view cancel px-2 py-1" type="button">
                                        <i class="fa fa-calendar-plus-o mr-1"></i>Schedule Make-up Class
                                    </button>
                                    <span *ngIf="attendance.makeup" class="color-primary font-weight-bold">{{ attendance.makeup }}</span>
                                    <span *ngIf="attendance.attendance === '1'">—</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- Curriculum -->
                <div *ngIf="activeTab === 'curriculum'">
                    <div class="curriculum-toolbar">
                        <div class="curriculum-filters">
                            <div class="filter-field">
                                <label class="toolbar-label">Class</label>
                                <ng-select [items]="classFilterOptions" bindLabel="class_name" bindValue="class_id"
                                           placeholder="All Class" [ngModel]="selectedCurriculumClassId"
                                           (change)="curriculumClassFilter($event)"></ng-select>
                            </div>
                            <div class="filter-field">
                                <label class="toolbar-label">Content Type</label>
                                <select class="form-control custom-select" [(ngModel)]="curriculumContentTypeFilter"
                                        (change)="onCurriculumContentTypeChange()">
                                    <option *ngFor="let opt of curriculumContentTypeOptions" [value]="opt.value">
                                        {{ opt.label }}
                                    </option>
                                </select>
                            </div>
                            <span class="curriculum-count">{{ curriculumListData.length }} items</span>
                        </div>
                    </div>

                    <div *ngIf="curriculumListData.length === 0" class="curriculum-empty">
                        <i class="fa fa-folder-open-o"></i>
                        <p>No curriculum items match your filters.</p>
                    </div>

                    <div class="curriculum-table-wrap" *ngIf="curriculumListData.length > 0">
                        <div class="curriculum-grid curriculum-grid-head">
                            <span class="grid-head-cell">Content</span>
                            <span class="grid-head-cell">Type</span>
                            <span class="grid-head-cell">Class</span>
                            <span class="grid-head-cell">Date range</span>
                            <span class="grid-head-cell grid-head-right">Score / Status</span>
                        </div>
                        <div class="curriculum-list">
                            <div *ngFor="let item of curriculumListData" class="curriculum-grid curriculum-grid-row"
                                 [ngClass]="curriculumRowAccentClass(item)">
                                <div class="grid-cell cell-content">
                                    <div class="content-thumb-wrap">
                                        <img [src]="curriculumThumb" alt="" class="curriculum-thumb">
                                        <span class="format-tag">{{ item.content_format }}</span>
                                    </div>
                                    <h6 class="content-title" [title]="item.content_name">{{ item.content_name }}</h6>
                                </div>
                                <div class="grid-cell cell-type">
                                    <span class="type-pill" [ngClass]="contentTypeBadgeClass(item.content_type)">
                                        {{ item.content_type }}
                                    </span>
                                </div>
                                <div class="grid-cell cell-class">
                                    <span class="class-name-text" [title]="item.class_name">{{ item.class_name }}</span>
                                </div>
                                <div class="grid-cell cell-dates">
                                    <i class="fa fa-calendar-o mr-1 text-muted"></i>
                                    <span>{{ item.start_date }} – {{ item.end_date }}</span>
                                </div>
                                <div class="grid-cell cell-status">
                                    <div *ngIf="showAssessmentScore(item)" class="score-chip">
                                        <span class="score-main">{{ item.score }}/{{ item.total_score }}</span>
                                        <span class="score-sub">{{ item.percentage }}</span>
                                    </div>
                                    <span *ngIf="!showAssessmentScore(item)" class="status-pill"
                                          [class.status-done]="item.completed"
                                          [class.status-pending]="!item.completed && item.content_type === 'Assessment'">
                                        {{ curriculumStatusLabel(item) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Communications (In-App only) -->
                <div *ngIf="activeTab === 'communications'">
                    <div class="communications-header">
                        <h5 class="color-primary font-weight-bold mb-1">In-App Messages</h5>
                        <p class="text-muted mb-0">Notifications sent to the student within EdQuill (demo data).</p>
                    </div>
                    <div class="inapp-message-list">
                        <div *ngFor="let msg of communicationsData" class="inapp-message-card">
                            <div class="message-icon">
                                <i class="fa fa-bell"></i>
                            </div>
                            <div class="message-body">
                                <div class="message-top">
                                    <h6 class="message-subject">{{ msg.subject }}</h6>
                                    <span class="message-datetime">{{ msg.date }} · {{ msg.time }}</span>
                                </div>
                                <p class="message-preview">{{ msg.preview }}</p>
                                <span class="message-recipient"><i class="fa fa-user-o mr-1"></i>{{ msg.recipient }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Reports -->
                <div *ngIf="activeTab === 'reports'">
                    <div class="curriculum-toolbar">
                        <div class="curriculum-filters">
                            <div class="filter-field">
                                <label class="toolbar-label">Class</label>
                                <ng-select [items]="classFilterOptions" bindLabel="class_name" bindValue="class_id"
                                           placeholder="All Class" [ngModel]="selectedReportsClassId"
                                           (change)="reportsClassFilter($event)"></ng-select>
                            </div>
                            <span class="curriculum-count">{{ reportsListData.length }} reports</span>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead style="background: #cdd9f6">
                            <tr>
                                <th>Report Name</th>
                                <th>Class</th>
                                <th>Generated Date</th>
                                <th>Score / Summary</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="reportsListData.length === 0">
                                <td colspan="6" class="text-center color-primary py-4">No reports found for selected class.</td>
                            </tr>
                            <tr *ngFor="let report of reportsListData">
                                <td class="color-primary font-weight-bold">{{ report.report_name }}</td>
                                <td>{{ report.class_name }}</td>
                                <td>{{ report.generated_date }}</td>
                                <td>{{ report.score }}</td>
                                <td>
                                    <span class="badge" [class.badge-success]="report.status === 'Published'"
                                          [class.badge-warning]="report.status === 'Draft'">{{ report.status }}</span>
                                </td>
                                <td>
                                    <button class="btn btn-outline-primary btn-sm" type="button">View</button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #assignmentModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title color-primary">Assignment Details</h4>
        <i class="fa fa-close fa-lg mt-1 cursor" style="color:#7F3486" (click)="closeAssignmentModal()" aria-hidden="true"></i>
    </div>
    <div class="modal-body">
        <p class="mb-3" *ngIf="selectedClassForModal">
            <strong class="color-primary">{{ selectedClassForModal.class_name }}</strong>
            <span class="text-muted ml-2">({{ selectedClassForModal.class_code }})</span>
        </p>
        <div class="row mb-3">
            <div class="col-md-4">
                <label class="font-weight-bold">Content Type</label>
                <select class="custom-select" [(ngModel)]="contentTypeFilter" (change)="onContentTypeChange()">
                    <option value="0">All</option>
                    <option value="2">Assignment</option>
                </select>
            </div>
            <div class="col-md-4 offset-md-4">
                <label class="font-weight-bold" style="visibility: hidden">Search</label>
                <div class="input-group">
                    <input type="text" class="form-control" placeholder="Search Content"
                           [(ngModel)]="searchContent" (input)="onSearchContent()">
                    <div class="input-group-append">
                        <button class="btn btn-primary" type="button"><i class="fa fa-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <label class="font-weight-bold mr-2">Assignment Type</label>
            <small *ngFor="let item of assignmentLegend" class="ml-3">
                <i class="fa fa-square p-1" [ngClass]="item.class"></i> — {{ item.label }}
            </small>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-sm">
                <thead style="background: #cdd9f6">
                <tr>
                    <th>Content Name</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Score</th>
                    <th>Percentage</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="assignmentRows.length === 0">
                    <td colspan="6" class="text-center text-muted">No data to display</td>
                </tr>
                <tr *ngFor="let row of assignmentRows">
                    <td class="color-primary font-weight-bold">{{ row.content_name }}</td>
                    <td>{{ row.start_date }}</td>
                    <td>{{ row.end_date }}</td>
                    <td>{{ row.score }} / {{ row.total_score }}</td>
                    <td>{{ row.percentage }}</td>
                    <td>
                        <i class="fa fa-square p-1" [ngClass]="row.statusClass"></i>
                        {{ row.status }}
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="text-muted small mt-1">{{ assignmentRows.length }} total</div>
        </div>
    </div>
</ng-template>
